// Huishouden (sprint 4): boodschappen, recepten, weekmenu, voorraad en de kiosk-ingang Eten.
// Handgeschreven zoals index.ts en gelijk aan de API (openapi.contract.test.ts leest ook dit
// bestand). Kiosk-veilig: alleen types en fetch-aanroepen, geen Zod-runtime.
export function createFoodApi(h) {
    const { get, post, patch, del, request, id, query, baseUrl } = h;
    return {
        /** EventSource-URL voor realtime pokes in de webapp. */
        liveUrl: () => `${baseUrl}/v1/app/live`,
        mediaUrl: (mediaId, size = 'full') => `${baseUrl}/v1/app/media/${id(mediaId)}${size === 'thumb' ? '?size=thumb' : ''}`,
        lists: {
            list: () => get('/v1/app/shopping/lists'),
            create: (input) => post('/v1/app/shopping/lists', input),
            update: (listId, input) => patch(`/v1/app/shopping/lists/${id(listId)}`, input),
            archive: (listId) => del(`/v1/app/shopping/lists/${id(listId)}`),
            restore: (listId) => post(`/v1/app/shopping/lists/${id(listId)}/restore`, {}),
            detail: (listId) => get(`/v1/app/shopping/lists/${id(listId)}`),
            addItem: (listId, input) => post(`/v1/app/shopping/lists/${id(listId)}/items`, input),
            clearChecked: (listId) => post(`/v1/app/shopping/lists/${id(listId)}/clear-checked`, {}),
        },
        items: {
            update: (itemId, input) => patch(`/v1/app/shopping/items/${id(itemId)}`, input),
            remove: (ids) => post('/v1/app/shopping/items/remove', { ids }),
            restore: (ids) => post('/v1/app/shopping/items/restore', { ids }),
            revertAdd: (result) => post('/v1/app/shopping/items/revert-add', {
                inserted_ids: result.inserted_ids,
                restored: result.previous,
            }),
        },
        recipes: {
            list: (q) => get(`/v1/app/recipes${query({ q })}`),
            get: (recipeId) => get(`/v1/app/recipes/${id(recipeId)}`),
            create: (input) => post('/v1/app/recipes', input),
            update: (recipeId, input) => patch(`/v1/app/recipes/${id(recipeId)}`, input),
            archive: (recipeId) => del(`/v1/app/recipes/${id(recipeId)}`),
            restore: (recipeId) => post(`/v1/app/recipes/${id(recipeId)}/restore`, {}),
            import: (url) => post('/v1/app/recipes/import', { url }),
            uploadPhoto: (recipeId, input) => post(`/v1/app/recipes/${id(recipeId)}/photo`, input),
            removePhoto: (recipeId) => del(`/v1/app/recipes/${id(recipeId)}/photo`),
            toList: (recipeId, input = {}) => post(`/v1/app/recipes/${id(recipeId)}/to-list`, input),
        },
        menu: {
            list: (from, to) => get(`/v1/app/menu${query({ from, to })}`),
            put: (date, input) => request('PUT', `/v1/app/menu/${id(date)}`, input),
            /** 0024: vijf voorstellen voor de week van `from` (hooguit 3 uit de eigen keukens). */
            suggestions: (from) => get(`/v1/app/menu/suggestions${query({ from })}`),
            remove: (date) => del(`/v1/app/menu/${id(date)}`),
            move: (date, to) => post(`/v1/app/menu/${id(date)}/move`, { to }),
            toList: (input) => post('/v1/app/menu/to-list', input),
        },
        pantry: {
            list: () => get('/v1/app/pantry'),
            add: (name, icon) => post('/v1/app/pantry', icon ? { name, icon } : { name }),
            update: (itemId, input) => patch(`/v1/app/pantry/${id(itemId)}`, input),
            remove: (itemId) => del(`/v1/app/pantry/${id(itemId)}`),
            restore: (itemId) => post(`/v1/app/pantry/${id(itemId)}/restore`, {}),
            suggestions: () => get('/v1/app/pantry/suggestions'),
        },
        /** 0024: wat verborgen is in de pictogramkiezer, en "eet iets anders". */
        profileCatalog: {
            pictos: (context) => get(`/v1/app/pictos${query({ context })}`),
            eatsOther: (recipeId, memberId, on) => on
                ? request('PUT', `/v1/app/profile/eats-other/${id(recipeId)}/${id(memberId)}`, { eats_other: true })
                : del(`/v1/app/profile/eats-other/${id(recipeId)}/${id(memberId)}`),
        },
    };
}
export function createKioskFoodApi(h) {
    const { get, post, id, baseUrl } = h;
    return {
        eten: () => get('/v1/kiosk/eten'),
        add: (input) => post('/v1/kiosk/eten/items', input),
        check: (itemId, input) => post(`/v1/kiosk/eten/items/${id(itemId)}/check`, input),
        remove: (itemId, input) => post(`/v1/kiosk/eten/items/${id(itemId)}/remove`, input),
        mediaUrl: (mediaId, size = 'thumb') => `${baseUrl}/v1/kiosk/media/${id(mediaId)}${size === 'thumb' ? '?size=thumb' : ''}`,
    };
}
//# sourceMappingURL=food.js.map